import { render, staticRenderFns } from "./MyGlasses.vue?vue&type=template&id=6d34b116&"
import script from "./MyGlasses.vue?vue&type=script&lang=ts&"
export * from "./MyGlasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports